import React from 'react';
import { InstagramIcon, FacebookIcon, TwitterIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-navy-900 text-white py-12" data-id="element-113">
      <div className="max-w-7xl mx-auto px-6" data-id="element-114">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-115">
          {/* Brand */}
          <div className="space-y-4" data-id="element-116">
            <h3 className="font-serif text-2xl text-gold-400" data-id="element-117">
              El Trío Esencial™
            </h3>
            <p className="text-gray-400 text-sm" data-id="element-118">
              Transformando la vida de mujeres latinas, una noche a la vez.
            </p>
          </div>

          {/* Links */}
          <div className="space-y-4" data-id="element-119">
            <h4 className="font-bold text-lg" data-id="element-120">Enlaces Rápidos</h4>
            <ul className="space-y-2 text-gray-400 text-sm" data-id="element-121">
              <li data-id="element-122">
                <a href="#" className="hover:text-pink-400 transition-colors" data-id="element-123">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-124">
                <a href="#" className="hover:text-pink-400 transition-colors" data-id="element-125">
                  Política de Privacidad
                </a>
              </li>
              <li data-id="element-126">
                <a href="#" className="hover:text-pink-400 transition-colors" data-id="element-127">
                  Política de Reembolso
                </a>
              </li>
              <li data-id="element-128">
                <a href="#" className="hover:text-pink-400 transition-colors" data-id="element-129">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className="space-y-4" data-id="element-130">
            <h4 className="font-bold text-lg" data-id="element-131">Síguenos</h4>
            <div className="flex gap-4" data-id="element-132">
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors" data-id="element-133">
                <InstagramIcon className="w-5 h-5" data-id="element-134" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors" data-id="element-135">
                <FacebookIcon className="w-5 h-5" data-id="element-136" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors" data-id="element-137">
                <TwitterIcon className="w-5 h-5" data-id="element-138" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors" data-id="element-139">
                <MailIcon className="w-5 h-5" data-id="element-140" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400 text-sm" data-id="element-141">
          <p data-id="element-142">
            © 2024 El Trío Esencial del Bienestar Latino™. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-143">Hecho con 💖 para mujeres latinas poderosas</p>
        </div>
      </div>
    </footer>;
}